import { render, staticRenderFns } from "./MerchantInsurance.vue?vue&type=template&id=22c11246"
import script from "./MerchantInsurance.vue?vue&type=script&lang=js"
export * from "./MerchantInsurance.vue?vue&type=script&lang=js"
import style0 from "./MerchantInsurance.vue?vue&type=style&index=0&id=22c11246&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports